import { TransactionStatusLabels } from 'src/app/app.models';

export function getTransactionStatus(
  trnStatus: string,
  labels: TransactionStatusLabels
): any {
  let helpText = '';
  let status = '';
  // console.log("trnStatus : ", trnStatus);
  // console.log("LABELS : ", labels);
  switch (trnStatus?.toLowerCase()) {
    case 'pending_user_transfer_start':
      status = labels?.status?.waitingForPayment;
      helpText =
        'Your wallet balance will be updated within a few minutes after payment.';
      break;
    case 'expired':
      helpText = labels?.status?.expiredHelpText;
      status = labels?.status?.expired;
      break;
    case 'incomplete':
      helpText = labels?.status?.incompleteHelpText;
      status = labels?.status?.incomplete;
      break;
    case 'pending_user_transfer_complete':
      status = labels?.status?.transactionReadyForPickup;
      break;
    case 'refunded':
      status = labels?.status?.transactionRefunded;
      break;
    case 'completed':
      status = labels?.status?.transactionComplete;
      break;
    case 'pending_anchor':
      status = labels?.status?.transactionProcessing;
      break;
    case 'refund_only':
      status = labels?.status?.refundOnly;
      break;
    case 'error':
      status = labels?.status?.transactionRejected;
      break;
    default:
      status = trnStatus;
  }
  const stat = {
    helpText,
    status,
  };
  // console.log("STATS : ", stat);
  return stat;
}
